import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';

interface GeneratePrescreenLinkParams {
  jobId: string;
  candidateId: string;
}

export const useGeneratePrescreenLinkMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, candidateId }: GeneratePrescreenLinkParams) => {
      const { data } = await fetchClient.POST(
        candidateEndpoints.prescreenLink,
        {
          params: {
            path: {
              jobId,
              candidateId,
            },
          },
        },
      );

      return data;
    },
  });
};
